import "core-js/modules/es.array.push.js";
import { reactive, toRefs, ref } from "vue";
import { loginApi } from "../../util/request";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
// import {LoginData,LoginResData} from './type'

export default {
  setup() {
    const router = useRouter();
    const data = reactive({
      loading: false,
      userinfo: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [{
          required: true,
          message: '账号不能为空',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      }
    });
    const loginForm = ref(null);
    const loginBtnHandle = () => {
      loginForm.value.validate(valid => {
        if (valid) {
          // 表单验证通过，执行登录操作
          doLogin();
        } else {
          // 表单验证不通过，显示错误提示
          ElMessage('用户名密码不能为空');
        }
      });
    };
    const doLogin = () => {
      // data.loading = true
      loginApi(data.userinfo).then(res => {
        console.log(res);
        // data.loading =false
        if (res && res.status === 0) {
          localStorage.setItem("userInfo", JSON.stringify(res.user));
          // store.commit("user/setUserInfo", res.user);

          // console.log(store.getters['user/getUserInfo'])
          router.push({
            path: "/account/list"
          });
        } else {
          ElMessage(res.message);
        }
      }, err => {
        console.log(err);
      });
    };
    return {
      ...toRefs(data),
      loginForm,
      loginBtnHandle
    };
  }
};